import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { ImageExercise } from './components/ImageExercise';
import { ResultsSection } from './components/ResultsSection';
import { ChatBot } from './components/ChatBot';
import { CTASection } from './components/CTASection';
export function App() {
  const [selectedImages, setSelectedImages] = useState<number[]>([]);
  const [exerciseComplete, setExerciseComplete] = useState(false);
  useEffect(() => {
    // Disable browser's automatic scroll restoration (mobile Safari, Chrome)
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
    // Fallback for mobile browsers that restore scroll after initial paint
    const timeout = setTimeout(() => window.scrollTo(0, 0), 0);
    const timeout2 = setTimeout(() => window.scrollTo(0, 0), 100);
    return () => {
      clearTimeout(timeout);
      clearTimeout(timeout2);
    };
  }, []);
  const handleExerciseComplete = (images: number[]) => {
    setSelectedImages(images);
    setExerciseComplete(true);
  };
  return <div className="font-poppins bg-lightgray min-h-screen text-gray-900" data-id="element-0">
      <HeroSection data-id="element-1" />

      <ImageExercise onComplete={handleExerciseComplete} isComplete={exerciseComplete} data-id="element-2" />

      <ResultsSection selectedImages={selectedImages} isVisible={exerciseComplete} data-id="element-3" />

      <ChatBot selectedImages={selectedImages} data-id="element-4" />

      <CTASection exerciseComplete={exerciseComplete} data-id="element-5" />
    </div>;
}